<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
    <sidenav-router-link v-if="this.$route.matched[0].name == 'AML'" icon="lnr d-block lnr-select" :active="isMenuActive('/Aml/Requests')" :open="isMenuOpen('/Aml/Requests')" to="/Aml/Requests" :exact="true"><span class="e-nusx-8">მოთხოვნები</span></sidenav-router-link>
    <!-- <sidenav-menu icon="lnr d-block lnr-select" :active="isMenuActive('/Aml')" :open="isMenuOpen('/Aml')" v-if="this.$route.matched[0].name == 'AML'">
            <template slot="link-text"><span class="e-nusx-8">მოთხოვნები</span></template>
            <sidenav-router-link to="/Aml/Requests" :exact="true"><span class="e-nusx-8">ყველა მოთხოვნა</span></sidenav-router-link> -->
            <!-- <sidenav-router-link to="/Aml/Requests/NotProcessedRequests" :exact="true"><span class="e-nusx-8">დაუმუშავებელი</span></sidenav-router-link>
            <sidenav-router-link to="/Aml/Requests/ApprovedRequests" :exact="true"><span class="e-nusx-8">დადასტურებული</span></sidenav-router-link>
            <sidenav-router-link to="/Aml/Requests/BlockedRequests" :exact="true"><span class="e-nusx-8">დაბლოკილი</span></sidenav-router-link> -->
    <!-- </sidenav-menu> -->
    <sidenav-menu icon="lnr d-block lnr-list" :active="isMenuActive('/Aml')" :open="isMenuOpen('/Aml')" v-if="this.$route.matched[0].name == 'AML'">
            <template slot="link-text"><span class="e-nusx-8">დამატებითი სიები</span></template>
            <!-- <sidenav-router-link to="/Aml/Lists/WhiteList" :exact="true"><span class="e-nusx-8">თეთრი სია</span></sidenav-router-link> -->
            <sidenav-router-link to="/Aml/Lists/BlackList" :exact="true"><span class="e-nusx-8">შავი სია</span></sidenav-router-link>
    </sidenav-menu>
    <sidenav-router-link v-if="this.$route.matched[0].name == 'AML'" icon="lnr d-block lnr-users" :active="isMenuActive('/AML/ClientDBScreening')" :open="isMenuOpen('/AML/ClientDBScreening')" to="/AML/ClientDBScreening" :exact="true"><span class="e-nusx-8">კლიენტთა ბაზის სქრინინგი</span></sidenav-router-link>
    <!-- <sidenav-router-link v-if="this.$route.matched[0].name == 'AML'" icon="lnr d-block lnr-spell-check" :active="isMenuActive('/Aml/TransactionSubjects/SubjectRequests')" :open="isMenuOpen('/Aml/TransactionSubjects/SubjectRequests')" to="/Aml/TransactionSubjects/SubjectRequests" :exact="true"><span class="e-nusx-8">დანიშნულების სქრინინგი</span></sidenav-router-link> -->
    <sidenav-menu icon="lnr d-block lnr-sync" :active="isMenuActive('/Aml')" :open="isMenuOpen('/Aml')" v-if="this.$route.matched[0].name == 'AML'">
            <template slot="link-text"><span class="e-nusx-8">მონაცემთა ბაზის განახლება</span></template>
            <sidenav-router-link to="/Aml/DBUpdates/UN" :exact="true"><span class="e-eng-font">UN</span></sidenav-router-link>
            <sidenav-router-link to="/Aml/DBUpdates/USA" :exact="true"><span class="e-eng-font">USA</span></sidenav-router-link>
            <sidenav-router-link to="/Aml/DBUpdates/UK" :exact="true"><span class="e-eng-font">UK</span></sidenav-router-link>
            <sidenav-router-link to="/Aml/DBUpdates/EU" :exact="true"><span class="e-eng-font">EU</span></sidenav-router-link>
    </sidenav-menu>
    <sidenav-menu icon="lnr d-block lnr-cog" :active="isMenuActive('/System')" :open="isMenuOpen('/System')" v-if="this.$route.matched[0].name == 'System'">
            <template slot="link-text"><span class="e-nusx-8">გლობალური პარამეტრები</span></template>
            <sidenav-router-link to="/System/ScanningSettings" :exact="true" class="test"><span class="e-nusx-8 e-whitespace-nowrap">სკანირების პარამეტრები</span></sidenav-router-link>
            <!-- <sidenav-router-link to="/System/WhiteListSettings" :exact="true"><span class="e-nusx-8 e-whitespace-nowrap">თეთრი სიის პარამეტრები</span></sidenav-router-link> -->
            <!-- <sidenav-router-link to="/System/GeneralSettings" :exact="true" class="test"><span class="e-nusx-8 e-whitespace-nowrap">ზოგადი პარამეტრები</span></sidenav-router-link> -->
            <sidenav-router-link to="/System/BlackListSettings" :exact="true"><span class="e-nusx-8 e-whitespace-nowrap">შავი სიის პარამეტრები</span></sidenav-router-link>
      </sidenav-menu>
      <sidenav-router-link v-if="this.$route.matched[0].name == 'System'" icon="lnr d-block lnr-users" :active="isMenuActive('/System/UsersManagement')" :open="isMenuOpen('/System/UsersManagement')" to="/System/UsersManagement" :exact="true"><span class="e-nusx-8">სისტემის მომხმარებლები</span></sidenav-router-link>
      <sidenav-router-link v-if="this.$route.matched[0].name == 'System' && this.currentUser === 1706" icon="lnr d-block lnr-lock" :active="isMenuActive('/System/Billing')" :open="isMenuOpen('/System/Billing')" to="/System/Billing" :exact="true"><span class="e-nusx-8">ბილინგი</span></sidenav-router-link>
      <!-- <sidenav-router-link icon="ion ion-md-desktop" to="/Aml/Lists/BlackList" :exact="true" class="e-nusx-8">შავი სია</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-desktop" to="/Aml/Lists/WhiteList" :exact="true" class="e-nusx-8">თეთრი სია</sidenav-router-link> -->
      <!-- {{ this.currentUser }} -->
    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },
  // data () {
  //   return {
  //     currentUser: this.$store.getters.GetCurrentUser.id
  //   }
  // },
  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    },
    currentUser () {
      return this.$store.getters.GetCurrentUser.id
    }
  },
  created () {
    console.log(this)
  },
  methods: {
    test () {
    },
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },
    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
